"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCompactVerbosity = toCompactVerbosity;
const toCompactVerbosityChatML_1 = require("./chatML/toCompactVerbosityChatML");
/**
 * Returns a compact representation of IO data for display in tables.
 * Strategy: Try ChatML extraction if possible.
 *
 * @param io - The input or output data to compact
 * @returns Compact representation or null if no data
 */
function toCompactVerbosity(io) {
    if (io === undefined || io === null)
        return { success: false, data: null };
    // Parse stringified JSON if needed
    let parsedIO = io;
    if (typeof io === "string") {
        try {
            parsedIO = JSON.parse(io);
        }
        catch {
            // Continue with original input
        }
    }
    // Try ChatML compact representation extraction
    const chatMLCompact = (0, toCompactVerbosityChatML_1.toCompactVerbosityChatML)(parsedIO);
    if (chatMLCompact.success) {
        return { success: true, data: chatMLCompact.data };
    }
    return { success: false, data: null };
}
